import { gql } from 'urql';

export const VACACION_FIELDS = gql`
  fragment VacacionFields on Vacacion {
    id
    empleadoId
    empleadoNombre
    sucursalId
    sucursalNombre
    periodo
    desde
    hasta
    diasTomados
    diasRestantes
    estado
    aprobadorId
    aprobadorNombre
    notas
  }
`;

export const VACACIONES_LIST = gql`
  query VacacionesList($filters: VacacionesFiltersInput, $pagination: PaginationInput, $order: VacacionOrderInput) {
    vacaciones(filters: $filters, pagination: $pagination, order: $order) {
      total
      pageInfo {
        page
        perPage
        totalItems
        totalPages
      }
      items {
        ...VacacionFields
      }
    }
  }
  ${VACACION_FIELDS}
`;

export const VACACION_BY_ID = gql`
  query VacacionById($id: ID!) {
    vacacion(id: $id) {
      ...VacacionFields
    }
  }
  ${VACACION_FIELDS}
`;

export const VACACION_CREATE = gql`
  mutation VacacionCreate($input: VacacionInput!) {
    vacacionCreate(input: $input) {
      ...VacacionFields
    }
  }
  ${VACACION_FIELDS}
`;

export const VACACION_UPDATE = gql`
  mutation VacacionUpdate($id: ID!, $input: VacacionInput!) {
    vacacionUpdate(id: $id, input: $input) {
      ...VacacionFields
    }
  }
  ${VACACION_FIELDS}
`;

export const VACACION_DELETE = gql`
  mutation VacacionDelete($id: ID!) {
    vacacionDelete(id: $id)
  }
`;

export const VACACION_APPROVE = gql`
  mutation VacacionApprove($id: ID!, $aprobadorId: ID) {
    vacacionApprove(id: $id, aprobadorId: $aprobadorId) {
      ...VacacionFields
    }
  }
  ${VACACION_FIELDS}
`;

export const VACACION_REJECT = gql`
  mutation VacacionReject($id: ID!, $aprobadorId: ID) {
    vacacionReject(id: $id, aprobadorId: $aprobadorId) {
      ...VacacionFields
    }
  }
  ${VACACION_FIELDS}
`;

export const VACACION_SET_GOCE = gql`
  mutation VacacionSetGoce($id: ID!) {
    vacacionSetGoce(id: $id) {
      ...VacacionFields
    }
  }
  ${VACACION_FIELDS}
`;
